import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type Props = {
  page: number;
  totalPages: number;
  totalItems: number;
  limit: number;
  onPrevious: () => void;
  onNext: () => void;
  isPreviousDisabled: boolean;
  isNextDisabled: boolean;
  className?: string;
  hideOnSinglePage?: boolean;
};

const SimplePagination = ({
  page,
  totalPages,
  totalItems,
  limit,
  onPrevious,
  onNext,
  isPreviousDisabled,
  isNextDisabled,
  className,
  hideOnSinglePage = false,
}: Props) => {
  if (hideOnSinglePage && totalPages <= 1) return null;

  return (
    <div className={cn('flex items-center justify-center gap-6', className)}>
      <div className="text-foreground text-sm font-semibold">
        {page * limit - limit + 1}-{page === totalPages ? totalItems : page * limit}{' '}
        <span className="text-muted-foreground font-normal">of {totalItems}</span>
      </div>
      <div className="flex gap-3">
        <Button variant="outline" size="icon" onClick={onPrevious} disabled={isPreviousDisabled}>
          <ChevronLeft />
        </Button>
        <Button variant="outline" size="icon" onClick={onNext} disabled={isNextDisabled}>
          <ChevronRight />
        </Button>
      </div>
    </div>
  );
};

export { SimplePagination };
